(function () {
	'use strict';
	angular.module('app.setup')
		.controller('projectCategories', projectCategories);

	projectCategories.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$compile', 'storeService',
		'tableService', 'leanFilterService', 'projectCategoriesService', 'tableRenderService'];
	function projectCategories($scope, $rootScope, $timeout, $uibModal, $compile, storeService,
			tableService, leanFilterService, projectCategoriesService, tableRenderService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'LeanProjectCategories';
		var getSpecialControl;
		// Extra query params to send to backend in data requests
		var extraParams = [{
			'name': 'showArchive',
			'value': false
		}];
		var rendererParams = {
			'controllerName': 'projectCategories'
		};

		$scope.filterService = leanFilterService;
		$scope.processArchive = processArchive;
		vm.useSiteSwitcher = true;
		vm.showExcel = false;
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.updateProjectCategoryStatus = updateProjectCategoryStatus;
		vm.saveProjectCategory = saveProjectCategory;
		vm.deleteProjectCategory = deleteProjectCategory;
		vm.addProjectCategory = addProjectCategory;
		vm.reportName = 'Project Categories';
		vm.showAddProjectCategory = vm.isAdmin;

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				if (response) {
					vm.categories = response[0].data;
				}
				return response;
			});
		}

		var columns = [
			{
				'id': 'name',
				'display': 'Category Name',
				'renderer': tableRenderService.projectCategoryRenderer,
				'deleteFunction': 'deleteProjectCategory',
				'requiredPermission': 'admin',
				'width': 400
			},
			{
				'id': 'noOfActiveLeanProjects',
				'display': '# of Active Lean Projects',
				'renderer': tableRenderService.integerWithLink,
				'urlGenerator': urlGenerator,
				'ndxField': 'name',
				'disableLinkForEmptyOrZero': true
			},
			{
				'id': 'noOfActiveSupplierProjects',
				'display': '# of Active Supplier Projects',
				'renderer': tableRenderService.integerWithLink,
				'urlGenerator': urlGenerator,
				'ndxField': 'name',
				'disableLinkForEmptyOrZero': true
			},
			{
				'id': 'noOfArchiveLeanProjects',
				'display': '# of Archive Lean Projects',
				'renderer': tableRenderService.integerWithLink,
				'ndxField': 'name',
				'disableLinkForEmptyOrZero': true,
				'urlGenerator': urlGenerator
			},
			{
				'id': 'noOfArchiveSupplierProjects',
				'display': '# of Archive Supplier Projects',
				'renderer': tableRenderService.integerWithLink,
				'ndxField': 'name',
				'disableLinkForEmptyOrZero': true,
				'urlGenerator': urlGenerator
			},
			{
				'id': 'noOfTemplates',
				'renderer': tableRenderService.integer,
				'display': '# of Project Templates',
				'width': 100
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/ProjectCategoriesReport',
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true,
			isGlobalReportSetting: true
		};

		var getSpecialControls = function () {
			var specialControl = document.getElementById('specialControls');

			if (specialControl) {
				clearInterval(getSpecialControl);
				addSpecialControl();
			}
		};

		function addSpecialControl() {
			$scope.showArchive = false;
			var template = '<div style=\"display: inline-block;bottom: 0px;vertical-align: bottom;line-height: 27px;position: absolute;\">' +
				'<span style=\"font-weight:bold;font-size:14px;\" translate>Show Archived</span> <input type=\"checkbox\" ng-change=\"processArchive()\" ng-model=\"showArchive\"></div>';
			var compiledDiv = $compile(template)($scope);

			jQuery('#specialControls').append(compiledDiv);
		}

		function processArchive() {
			var showArchiveIndex = _.findIndex(extraParams, ['name', 'showArchive']);
			if (showArchiveIndex !== -1) {
				extraParams[showArchiveIndex].value = $scope.showArchive;
			} else {
				extraParams.push({
					'name': 'showArchive',
					'value': $scope.showArchive
				});
			}
			$scope.$broadcast('reloadTable');
		}

		function init() {
			getSpecialControl = setInterval(getSpecialControls, 200);
			$scope.filterService.clearFilters();
			$scope.filterService.useAdminFactory = true;
		}

		function urlGenerator(type, ndx, factoryNdxs, row) {
			var url = '/application/f/home.html#/lean-projects/view-projects/?drilldown=1&timePeriod=all&factory=' + adminConfig.factory.id;
			var stageIds = type.indexOf('Active') >= 0 ? row['activeStages'] : row['archiveStages'];
			if (type.indexOf('Supplier') >= 0) {
				url = '/application/f/home.html#/supply-chain/supplier-projects/?drilldown=1&timePeriod=all&factory=' + adminConfig.factory.id;
			}
			url += '&projectCategoryId=' + row.ndx;
			url += '&projectStageId=' + stageIds;
			return url;
		}

		function updateProjectCategoryStatus(projectCategory, status) {
			var confirmScope = $scope.$new();
			var statusConfirmText = projectCategory.status === 'Active' ? 'archive' : 'activate';
			confirmScope.additionalText = statusConfirmText + ' this project category';
			confirmScope.buttonText = projectCategory.status === 'Active' ? 'Archive' : 'Activate';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();
				projectCategory.status = status;
				saveProjectCategory(projectCategory, projectCategory.status === 'Active' ? 'activated' : 'archived');
			};
		}

		function deleteProjectCategory(projectCategory) {
			var projectDeleteCategoryFormScope = $scope.$new();
			projectDeleteCategoryFormScope.action = 'Delete Project';
			projectDeleteCategoryFormScope.projectCategory = angular.copy(projectCategory);
			projectDeleteCategoryFormScope.customerNdx = adminConfig.customer.id;
			if (vm.categories && vm.categories.length) {
				projectDeleteCategoryFormScope.categories = vm.categories.filter(function (category) {
					return category.ndx !== projectCategory.ndx;
				});
			}
			projectDeleteCategoryFormScope.deleteCallBack = removeProjectCategory;
			projectDeleteCategoryFormScope.replaceCallBack = replaceProjectCategory;
			var opts = {
				scope: projectDeleteCategoryFormScope,
				templateUrl: '/application/f/setup/projects/categories/project-categories-delete-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			projectDeleteCategoryFormScope.closeDialog = function () {
				instance.close();
				projectDeleteCategoryFormScope.$destroy();
			};

			projectDeleteCategoryFormScope.result = function () {
				instance.close();
				projectDeleteCategoryFormScope.$destroy();
			};
		}

		function addProjectCategory() {
			var projectCategoryFormScope = $scope.$new();
			projectCategoryFormScope.action = 'Add';
			projectCategoryFormScope.customerNdx = adminConfig.customer.id;
			projectCategoryFormScope.saveCallBack = saveProjectCategory;
			var opts = {
				scope: projectCategoryFormScope,
				templateUrl: '/application/f/setup/projects/categories/project-categories-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			projectCategoryFormScope.closeDialog = function () {
				instance.close();
				projectCategoryFormScope.$destroy();
			};

			projectCategoryFormScope.result = function () {
				instance.close();
				projectCategoryFormScope.$destroy();
			};
		}

		function saveProjectCategory(category, additionalResultText) {
			return projectCategoriesService.saveProjectCategory(category, adminConfig.factory.id).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					var additionalText = additionalResultText || (category.ndx ? 'updated' : 'created');
					$rootScope.$emit('toast', {
						'message': 'Project category ' + additionalText + ' successfully',
						'success': true
					});
					$scope.$broadcast('reloadTable');
				} else {
					$rootScope.$emit('toast', {
						'message': response,
						'success': false
					});
				}
			});
		}

		function removeProjectCategory(projectCategoryNdx) {
			return projectCategoriesService.deleteCategory(projectCategoryNdx, adminConfig.factory.id).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					$rootScope.$emit('toast', {
						'message': 'Project category was deleted successfully',
						'success': true
					});
					$scope.$broadcast('reloadTable');
				} else {
					$rootScope.$emit('toast', {
						'message': response,
						'success': false
					});
				}
			});
		}

		function replaceProjectCategory(categoryNdx, newCategoryNdx) {
			return projectCategoriesService.replaceCategory(categoryNdx, newCategoryNdx, adminConfig.factory.id).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					$rootScope.$emit('toast', {
						'message': 'Project category was replaced successfully',
						'success': true
					});
					$scope.$broadcast('reloadTable');
				} else {
					$rootScope.$emit('toast', {
						'message': response,
						'success': false
					});
				}
			});
		}

		init();
	}
})();